import React, { Component } from "react";
import { connect } from "react-redux";

import ContentHeader from "@common/components/ContentHeader";
import NavigationContainer from "@workerhome/components/Content/Navigation";
import AssessmentLayout from "@workerhome/components/Content/Layouts";
import CompletionDialog from "@common/components/CompletionDialog";
import generatePdf from "@common/pdf";
import { ContentWrapper, ContentLayout } from "@common/styled/content";

class Content extends Component {
  render() {
    const { section, stepsMeta } = this.props;
    const { activeStep, activeSubStep } = stepsMeta;

    // Get current section and substeps
    const currentSubStep = section.subsections[activeSubStep];

    // Store whether the section is complete (for preventing navigation)
    const isSectionComplete = currentSubStep.risks.every(
      risk => risk.isRisk != null
    );
    //const isSectionComplete = true;

    // Store whether a risk has been indicated in the section (for displaying Appendix dialog)
    const isRiskIndicated = currentSubStep.risks.some(risk => risk.isRisk);

    return (
      <ContentWrapper>
        <ContentHeader>
          {currentSubStep.subTitle}
        </ContentHeader>
        <ContentLayout>
          <AssessmentLayout
            section={section}
            activeStep={activeStep}
            activeSubStep={activeSubStep}
          />
          <NavigationContainer
            isRiskIndicated={isRiskIndicated}
            isSectionComplete={isSectionComplete}
          />
        </ContentLayout>
        <CompletionDialog
          isShown={this.props.isCompletionDialogShown}
          title={section.title}
          pdfLinks={section.pdfLinks}
          onPdfClick={action =>
            generatePdf(section, action, "Home/Community Assessment")}
        />
      </ContentWrapper>
    );
  }
}

const mapStateToProps = store => {
  return {
    section: store.workerHome.app,
    stepsMeta: store.workerHome.sidebar.stepsMeta,
    isCompletionDialogShown: store.workerHome.app.ui.isCompletionDialogShown
  };
};

const ContentContainer = connect(mapStateToProps, null)(Content);
export default ContentContainer;



// WEBPACK FOOTER //
// ./src/workerhome/components/Content/ContentContainer.jsx